import React from 'react';
import { useHref, useLocation, useMatch, useNavigate } from 'react-router-dom';

const isModifiedEvent = (event: any) =>
    !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

type Props = {
    children: React.ReactElement,
    onClick?: (event?: any) => any,
    replace?: boolean,
    to: string | any,
    state?: any,
    className?: string,
    activeClassName?: string,
    style?: Record<string, any>,
    activeStyle?: Record<string, any>,
    isActive: (event?: any) => any | boolean,
};

const defaultProps = {
    replace: false,
    activeClassName: 'active',
    onClick: null,
    className: null,
    style: null,
    activeStyle: null,
    isActive: null,
};

const LinkContainer = ({
    children,
    onClick,
    replace, // eslint-disable-line no-unused-vars
    to,
    state,
    activeClassName,
    className,
    activeStyle,
    style,
    isActive: getIsActive,
    // eslint-disable-next-line comma-dangle
    ...props
}: Props) => {
    const path = typeof to === 'object' ? to.pathname || '' : to;
    const navigate = useNavigate();
    const href = useHref(typeof to === 'string' ? { pathname: to } : to);
    const match = useMatch(path);
    const location = useLocation();
    const child = React.Children.only(children);

    const isActive = !!(getIsActive
        ? typeof getIsActive === 'function'
            // ? getIsActive(match, location)
            ? getIsActive(match)
            : getIsActive
        : match);

    const handleClick = (event: any) => {
        if (children.props.onClick) {
            children.props.onClick(event);
        }

        if (onClick) {
            onClick(event);
        }

        if (
            !event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore right clicks
            !isModifiedEvent(event) // ignore clicks with modifier keys
        ) {
            event.preventDefault();

            navigate(to, {
                replace,
                state,
            });
        }
    };

    return React.cloneElement(child, {
        ...props,
        className: [
            className,
            child.props.className,
            isActive ? activeClassName : null,
        ]
            .join(' ')
            .trim(),
        style: isActive ? { ...style, ...activeStyle } : style,
        href,
        onClick: handleClick,
    });
};

LinkContainer.defaultProps = defaultProps;

export default LinkContainer;
